<script>
    import TextInput from '../TextInput/TextInput';

    export default {
        name: 'email-input',

        mixins: [TextInput],

        computed: {
            /**
             * Return the input type.
             *
             * @returns {string}
             */
            type() {
                return 'email';
            },
        },
    };
</script>
